"use client";

import { useState } from "react";
import { useMessages } from "@/lib/i18n/client";
import messages from "./email-field.i18n";

// Mismo criterio que el backend (class-validator IsEmail, en lo esencial):
// algo@dominio.ext, sin espacios.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}

// Campo de correo con validación propia (los formularios usan noValidate:
// el globo nativo del navegador no se ve bien ni sigue el idioma de la web).
// `validate()` devuelve true si se puede enviar; si no, deja el mensaje en
// `error`, que se borra apenas la persona vuelve a escribir.
export function useEmailField(initial = "") {
  const t = useMessages(messages);
  const [email, setEmailState] = useState(initial);
  const [error, setError] = useState("");

  const setEmail = (value: string) => {
    setEmailState(value);
    if (error) setError("");
  };

  const validate = (): boolean => {
    const message = !email.trim() ? t.empty : isValidEmail(email) ? "" : t.invalid;
    setError(message);
    return !message;
  };

  return { email: email.trim(), rawEmail: email, setEmail, error, validate };
}
